import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";

import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "primeicons/primeicons.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./assets/fonts/fonts.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { MQTTProvider } from "./services/mqttService";
import MuiTheme from "./theme/MuiTheme";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeProvider theme={MuiTheme}>
    <Provider store={store}>
      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={5000} />
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <MQTTProvider>
            <App />
          </MQTTProvider>
        </LocalizationProvider>
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
